import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GraphService } from 'src/app/services/graph.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Globals } from '../models/globals.model';
import { MsalService } from '@azure/msal-angular';
import { AuthError, InteractionRequiredAuthError } from '@azure/msal-browser';

@Component({
  selector: 'app-overage',
  templateUrl: './overage.component.html',
  styleUrls: ['./overage.component.css']
})
export class OverageComponent implements OnInit {

  groups: string[] = [];

  constructor(private readonly authService: MsalService, private readonly service: GraphService, private readonly http: HttpClient
    , private readonly router: Router
    , public readonly route: ActivatedRoute
    , public globals: Globals) { }

  ngOnInit(): void {
    this.handleResponse();
  }

  handleResponse(): void {
    this.service.getGroups().subscribe({
      next: (response: any) => {
        this.handleGroupResponse(response);
      },
      error: (err: AuthError) => {
        console.log(err)
        // If there is an interaction required error,
        // call one of the interactive methods and then make the request again.
        if (new InteractionRequiredAuthError(err.errorCode, err.errorMessage)) {
          this.authService.acquireTokenPopup({
            scopes: [this.globals.config.graphApi_client_resourceUri]
          })
            .subscribe(() => {
              this.service.getGroups()
                .subscribe((response: any) => {
                  this.handleGroupResponse(response);
                });
            });
        }
      }
    });
  }

  private handleGroupResponse(response:any) {
    response.value.map(v => this.groups.push(v.id));
    /**
     * Some queries against Microsoft Graph return multiple pages of data either due to server-side paging 
     * or due to the use of the $top query parameter to specifically limit the page size in a request. 
     * When a result set spans multiple pages, Microsoft Graph returns an @odata.nextLink property in 
     * the response that contains a URL to the next page of results.
     * learn more at https://docs.microsoft.com/graph/paging
     */
    if (response['@odata.nextLink']) {
      this.handleNextPage(response['@odata.nextLink'])
    } else {
      this.syncGroups();
    }
  }

  private syncGroups() {
    this.service.user.groupIDs = this.groups;
    this.route.params.subscribe(
      (params: Params) => {
        this.router.navigate(['/' + params.redirectPath]);
      });
  }

  handleNextPage(nextPage): void {
    this.service.getNextPage(nextPage)
      .subscribe((response: any) => {

        response.value.map(v => {
          if (!this.groups.includes(v.id)) {
            this.groups.push(v.id);
          }
        });

        if (response['@odata.nextLink']) {
          this.handleNextPage(response['@odata.nextLink'])
        } else {
          this.syncGroups();
        }
      })
  }
}
